/* @flow */

import type {
    DepItem,
    RawAnnotation
} from 'reactive-di'

import {rdi} from 'reactive-di/driver'

export function theme(...deps: Array<DepItem>): RawAnnotation {
    return {
        kind: 'theme',
        deps
    }
}

export function themeAnn<V: Function>(...deps: Array<DepItem>): (target: V) => V {
    return function __theme(target: V): V {
        rdi.set(target, {
            kind: 'theme',
            deps
        })
        return target
    }
}
